import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  lessonsSelector,
  LESSON_TYPES,
  setAssignment,
  setHomework,
  setLiveLecture,
  setPreRead,
  setContest,
} from 'features/classCreation';
import ToggleChip from 'components/ToggleChip';

export default function LessonChip({ lessonType, title }) {
  const dispatch = useDispatch();
  const lessons = useSelector(lessonsSelector);

  const handleAddLesson = useCallback(() => {
    switch (lessonType) {
      case LESSON_TYPES.assignment:
        dispatch(setAssignment({ lesson_type: lessonType }));
        break;
      case LESSON_TYPES.homework:
        dispatch(setHomework({ lesson_type: lessonType }));
        break;
      case LESSON_TYPES.liveLecture:
        dispatch(setLiveLecture({ lesson_type: lessonType }));
        break;
      case LESSON_TYPES.preRead:
        dispatch(setPreRead({ lesson_type: lessonType }));
        break;
      case LESSON_TYPES.contest:
        dispatch(setContest({ lesson_type: lessonType }));
        break;
      default:
        return null;
    }
  }, [lessonType, dispatch]);

  const handleRemoveLesson = useCallback(() => {
    switch (lessonType) {
      case LESSON_TYPES.assignment:
        dispatch(setAssignment(null));
        break;
      case LESSON_TYPES.homework:
        dispatch(setHomework(null));
        break;
      case LESSON_TYPES.liveLecture:
        dispatch(setLiveLecture(null));
        break;
      case LESSON_TYPES.preRead:
        dispatch(setPreRead(null));
        break;
      case LESSON_TYPES.contest:
        dispatch(setContest(null));
        break;
      default:
        return null;
    }
  }, [lessonType, dispatch]);

  return (
    <ToggleChip
      isAdded={Boolean(lessons[lessonType])}
      onAdd={handleAddLesson}
      onRemove={handleRemoveLesson}
      label={title}
      className="m-r-xs m-b-xxs"
    />
  );
}
